module.exports = __webpack_public_path__ + "img/product-7-INTguanhuai.97f8ad2a.png";